'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppBar = undefined;

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../identifiers');

var _AppBar = require('./AppBar');

var _button = require('../button');

var _theme = require('./theme.css');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppBar = (0, _AppBar.appBarFactory)(_button.IconButton);
var ThemedAppBar = (0, _reactCssThemr.themr)(_identifiers.APP_BAR, _theme2.default)(AppBar);

exports.default = ThemedAppBar;
exports.AppBar = ThemedAppBar;


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/app_bar/index.js
// module id = 656
// module chunks = 0